import React, {Component} from "react";

class LeaderboardRow extends Component {
    
    render() {
        const {player_data} = this.props;


        let rank = player_data.rank;

        if (rank === 1) {
            rank = <i className='fa fa-trophy leaderboard_first_place'></i>;
        }
        else if (rank === 2) {
            rank = <i className='fa fa-trophy leaderboard_second_place'></i>;
        }
        else if (rank === 3) {
            rank = <i className='fa fa-trophy leaderboard_third_place'></i>;
        }

        return (
            <tr>
                <td>{rank}</td>
                <td>{player_data.player_name}</td>
                <td>{player_data.high_score}</td>
            </tr>
        );
    }
}

export default LeaderboardRow;


// WEBPACK FOOTER //
// ./src/components/containers/leaderboard/leaderboard-row.js